var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "see-mail-modal"
  }, [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("收件信息")))])]), _c("a-form", {
    staticClass: "consignee-form",
    attrs: {
      form: _vm.mailingInfo.consigneeInfo,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("姓名")
    }
  }, [_vm._v(_vm._s(_vm.mailingInfo.consigneeInfo.name))]), _c("a-form-item", {
    attrs: {
      label: _vm.$t("电话")
    }
  }, [_vm._v(_vm._s(_vm.mailingInfo.consigneeInfo.mobile))]), _c("a-form-item", {
    attrs: {
      label: _vm.$t("详细地址")
    }
  }, [_vm._v(_vm._s(_vm.mailingInfo.consigneeInfo.address))])], 1), _c("top-title", {
    staticClass: "marginT20",
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("寄件信息")))])]), _c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.mailingInfo,
      rules: _vm.mailingRule,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("物流公司"),
      prop: "logisticsCompany"
    }
  }, [_vm.edit ? _c("a-select", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.mailingInfo.logisticsCompany,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "logisticsCompany", $$v);
      },
      expression: "mailingInfo.logisticsCompany"
    }
  }, _vm._l(_vm.logisticsSelectList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item,
        label: item
      }
    }, [_vm._v(_vm._s(item) + " ")]);
  }), 1) : _c("a-input", {
    attrs: {
      allowClear: "",
      readOnly: !_vm.edit
    },
    model: {
      value: _vm.mailingInfo.logisticsCompany,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "logisticsCompany", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "mailingInfo.logisticsCompany"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("运单号"),
      prop: "shipmentNum"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      readOnly: !_vm.edit
    },
    model: {
      value: _vm.mailingInfo.shipmentNum,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "shipmentNum", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "mailingInfo.shipmentNum"
    }
  })], 1)], 1), _vm.edit ? _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("提交")))])], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };